import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';

import '@/css/desktop/search';
import '@/css/desktop/atlas/landing-destinations-header.scss';
import '@/css/desktop/atlas/landing-content.css';
import '@/css/desktop/atlas/landing-destinations-list.css';

import tourCriteriaService from '@/js/common/Domain/Service/tourCriteria';
import RestTypesRepository from '@/js/common/Domain/Repository/RestTypes';
import DirectionsRepository from '@/js/common/Domain/Repository/Directions';
import SearchFromAutocomplete from '@/js/desktop/components/searchFormAutocomplete/searchFormAutocomplete-controller';
import ToursOnIndexView from './View/ToursOnIndex';
import SubscribeForm from '../atlas/View/SubscribeForm';

const Controller = Backbone.View.extend({
    view: null,
    initSubscribeForm() {
        new SubscribeForm();
    },
    initialize() {
        RestTypesRepository.repository.init(window.defaultRestTypes);
        DirectionsRepository.repository.init({
            directions: window.defaultDirections,
        });
        this.view = new ToursOnIndexView();

        /* don't change date with country defaults*/
        setTimeout(() => {
            tourCriteriaService.addTourCriteriaChangedField('checkInDateRange');
        }, 0);

        this.initSubscribeForm();
    },
});

$(() => {
    const searchController = new Controller({
        el: 'body',
    });

    new SearchFromAutocomplete({
        el: 'body',
    });
});